import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

class OpenEvent extends EventData<Openable> {

}

class OpenEventListener extends EventListener<Openable, OpenEvent, any> {
  constructor() {
    super(OpenEvent);
  }
}

export default interface Openable extends Mountable {

  /** @event */
  onOpen: OpenEventListener;

  open(): void;

  isOpen(): boolean;

}

export { OpenEventListener, OpenEvent };
